var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroll-bar',[_c('div',{staticClass:"sidebar-logo"},[_c('span',[_vm._v("管理系统")])]),_c('el-menu',{staticClass:"silder-el-menu",attrs:{"mode":"vertical","show-timeout":200,"default-active":_vm.$route.path,"collapse":_vm.isCollapse,"text-color":"#999","active-text-color":"#fff"}},[_c('sidebar-item',{attrs:{"routes":_vm.routes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }